import React from 'react'
import ClientAdd from '../../admin/ClientAdd'
import V3DataRouteShell from '../data/V3DataRouteShell'

export default function V3ClientAddPage() {
  return (
	<V3DataRouteShell>
	  <ClientAdd />
	</V3DataRouteShell>
  )
}

